export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "数据字典详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "字典名称：",
            type: "input",
            value: "zdmc",
            maxlength: 60,
            width: "100%;",
            rule: {
              required: true,
              message: "请填写字典名称",
              trigger: "blur"
            }
          },
          {
            label: "字典描述：",
            value: "zdms",
            type: "textarea",
            required: true,
            maxlength: 330,
            minRows: "3",
            maxRows: "2",
            width: "100%;",
            rule: {
              required: false,
              message: "请填写字典描述",
              trigger: "blur"
            }
          },          
        ]
      },
    ];
  }
}
